import { ScreenLayout as ScreenLayoutRoot } from "./screen-layout";
import { ScreenLayoutActions } from "./screen-layout-actions";
import {
  ScreenLayoutActionsContent,
  ScreenLayoutActionsPortal,
} from "./screen-layout-actions-portal";
import { ScreenLayoutBody } from "./screen-layout-body";
import { ScreenLayoutHeader } from "./screen-layout-header";

type ScreenLayoutComponent = typeof ScreenLayoutRoot & {
  Header: typeof ScreenLayoutHeader;
  Body: typeof ScreenLayoutBody;
  Actions: typeof ScreenLayoutActions;
  ActionsPortal: typeof ScreenLayoutActionsPortal;
  ActionsContent: typeof ScreenLayoutActionsContent;
};

const ScreenLayout = ScreenLayoutRoot as ScreenLayoutComponent;
ScreenLayout.Header = ScreenLayoutHeader;
ScreenLayout.Body = ScreenLayoutBody;
ScreenLayout.Actions = ScreenLayoutActions;
ScreenLayout.ActionsPortal = ScreenLayoutActionsPortal;
ScreenLayout.ActionsContent = ScreenLayoutActionsContent;

export { ScreenLayout };
export type {
  ScreenLayoutProps,
  ScreenLayoutHeaderProps,
  ScreenLayoutBodyProps,
  ScreenLayoutBodyHandle,
  ScreenLayoutActionsProps,
  ScreenLayoutActionsPortalProps,
  ScreenLayoutActionsContentProps,
  ScreenLayoutBackground,
  ScreenLayoutStatusBarFill,
  ScreenLayoutActionsSurface,
} from "./types";
